// extracted by mini-css-extract-plugin
export default {"Agb":"Agb_Agb__d-DJ6","headerText":"Agb_headerText__sb4-J"};